import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "antd";
import { GlobalOutlined } from "@ant-design/icons"

type LangTog =  {

  icon?:boolean;

}

const LanguageToggle: React.FC<LangTog>= ({icon}) => {

  const [isHovered, setIsHovered] = useState(false);
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18nextLng", newLang);
    
    // Clear all column configurations when language changes
    const columnKeys = [
      "neoPaas_terminals_table_columns",
      "neoPaas_users_table_columns",
      "neoPaas_branches_table_columns",
      "neoPaas_transaction_table_columns",
      "ecr_merchant_list_columns"
    ];
    
    columnKeys.forEach(key => localStorage.removeItem(key));
    
//     document.documentElement.lang = newLang;
// document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
window.location.reload();
  };

  return (
    <Button 
    icon={icon?<GlobalOutlined className={`transition-transform duration-300 ${isHovered ? "rotate-180" : ""}`}/>:false}
    onClick={toggleLanguage} 
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    className="transition-all duration-300 hover:shadow-md hover:scale-105 border-neo-primary/20 hover:border-neo-primary"
    type="default">
<Typography className="font-poppins-500" >
{i18n.language === "en" ? "العربية" : "English"}

</Typography>
    </Button>
  );
};

export default LanguageToggle;
